module.exports = Promise.resolve(module.bundle.root("i9Npn"))